var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEquipmentMaterialOutside({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.625H0V15.75H15.75V14.625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 5.625L3.6075 4.83L2.1525 3.375H6.75V2.25H2.1525L3.6075 0.795L2.8125 0L0 2.8125L2.8125 5.625Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9875 6.18H13.4025V5.5125C13.4025 4.9875 12.9825 4.5675 12.4725 4.5675H8.1525C7.6425 4.5675 7.2225 4.995 7.2225 5.5125V6.18H6.6375C5.7075 6.18 4.95 6.9375 4.95 7.8675V11.91C4.95 12.84 5.7075 13.5975 6.6375 13.5975H13.98C14.91 13.5975 15.6675 12.84 15.6675 11.91V7.8675C15.6675 6.9375 14.91 6.18 13.98 6.18H13.9875ZM8.3475 5.6925H12.27V6.18H8.3475V5.6925ZM6.6375 7.305H13.98C14.2875 7.305 14.5425 7.56 14.5425 7.8675V8.385H6.075V7.8675C6.075 7.56 6.33 7.305 6.6375 7.305ZM9.6825 9.51H10.9425V10.23H9.6825V9.51ZM6.645 12.465C6.3375 12.465 6.0825 12.21 6.0825 11.9025V9.51H8.565V11.355H12.075V9.51H14.5575V11.9025C14.5575 12.21 14.3025 12.465 13.995 12.465H6.645Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEquipmentMaterialOutside);
export default __webpack_public_path__ + "static/media/ic-equipment-material-outside.1452cf4983380be5ca14fa7618ec4094.svg";
export { ForwardRef as ReactComponent };